import { useRouter } from "next/router";
import useWindowStorage from "utils/hooks/useWindowStorage";

function isPossiblyAffiliateCode(value: unknown) {
  if (typeof value === "string") {
    return value.length > 3;
  }
  return false;
}

export default function useAffiliatedVisitor() {
  const router = useRouter();
  const [_, { getItem, setItem }] = useWindowStorage("sessionStorage");

  const affiliateKey = "extAffiliateCode";
  let storageValue = getItem(affiliateKey) || null;

  const queryParameterValue = router.query?.[affiliateKey] || null;

  setItem(affiliateKey, queryParameterValue);
  storageValue = queryParameterValue;

  const affiliateCode = storageValue;

  return {
    affiliateCode,
    isAffiliateVisitor: isPossiblyAffiliateCode(affiliateCode),
  };
}
